module.exports = __webpack_public_path__ + "img/brain.e28595fc.png";